export default function ButtonPage() {
  return <h3>This is ButtonPage Page</h3>;
}
